namespace GeniuzPOS.InitialData {
    export interface PsQRPromptPayForm {
        QRPromptPayType: Serenity.StringEditor;
        QRPromptPayName: Serenity.StringEditor;
        paymentChannel: Serenity.StringEditor;
        ProdImageLink: Serenity.ImageUploadEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class PsQRPromptPayForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsQRPromptPay';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsQRPromptPayForm.init)  {
                PsQRPromptPayForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ImageUploadEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(PsQRPromptPayForm, [
                    'QRPromptPayType', w0,
                    'QRPromptPayName', w0,
                    'paymentChannel', w0,
                    'ProdImageLink', w1,
                    'IsActive', w2
                ]);
            }
        }
    }
}
